import { render, staticRenderFns } from "./ModalInboxItem.vue?vue&type=template&id=0ae307bc"
import script from "./ModalInboxItem.vue?vue&type=script&lang=js"
export * from "./ModalInboxItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ParticipantsAvatars: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ParticipantsAvatars.vue').default})
